/* eslint-disable jsx-a11y/alt-text */
import { mask, masks, mask4, cardiver,emoji, redemoji, mask2, mask1, mask6, gameboardlogo } from "../assets";

const Dealopen = () => {
  return (
    <>
      <div className="background">
        <div className="gameboard container">
          <div className="row">
            <div className="col-md-6 col-12">
              <div className="mt-3">
                <img src={gameboardlogo} className="gameboard-logos" />
              </div>
            </div>
            <div className="col-md-2 col-12">
              <div className="box-1-set float-right mobile-top-set">
                <p className="brown-text">:27</p>
              </div>
            </div>
            <div className="col-md-4 col-12">
              <table className="table mt-5 game-table-width">
                <tbody>
                  <tr>
                    <th
                      scope="row"
                      className="border-right-color  font-table-head"
                    >
                      PLAYERS
                    </th>
                    <th colSpan="2" className="font-table-head">
                      OPEN SITUATIONS
                    </th>
                  </tr>
                  <tr>
                    <th
                      scope="row"
                      className="border-right-color  font-table-head"
                    >
                      lan
                    </th>
                    <td>
                      <img src={emoji} />
                      <img src={emoji} className="ml-2" />
                      <img src={emoji} className="ml-2" />
                      <img src={emoji} className="ml-2" />
                    </td>
                  </tr>
                  <tr>
                    <th
                      scope="row"
                      className="border-right-color  font-table-head"
                    >
                      Ryan
                    </th>
                    <td></td>
                  </tr>
                  <tr>
                    <th
                      scope="row"
                      className="border-right-color font-table-head"
                    >
                      Jodie
                    </th>
                    <td>
                      <img src={emoji} />
                      <img src={emoji} className="ml-2" />
                      <img src={emoji} className="ml-2" />
                      <img src={emoji} className="ml-2" />
                    </td>
                  </tr>
                  <tr>
                    <th
                      scope="row"
                      className="border-right-color  font-table-head"
                    >
                      Linda
                    </th>
                    <td>
                      {" "}
                      <img src={emoji} />
                      <img src={emoji} className="ml-2" />
                      <img src={emoji} className="ml-2" />
                      <img src={redemoji} className="width-set-game ml-2" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5 col-12">
              <div className="card-yellow">
                <div className="row">
                  <div className="col-md-4 col-5 mobile-top-game">
                    <h3 className="Pacifico-Regulars mobile-font-game font-family-size">
                      time/energy
                    </h3>
                  </div>
                  <div className="col-md-8 col-7">
                    <div className="float-right">
                      <div className="row">
                        <div className="back-box-game mr-2">
                          <img src={mask1} className="width-gane-image" />
                        </div>
                        <div className="back-box-game mr-2">
                          <img src={mask2} className="width-gane-image" />
                        </div>
                        <div className="back-box-game mr-3">
                          <img src={masks} className="width-gane-image" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-green mt-2">
                <div className="row">
                  <div className="col-md-4 col-5 mobile-top-game">
                    <h3 className="Pacifico-Regulars mobile-font-game font-family-size">
                      home/family
                    </h3>
                  </div>
                  <div className="col-md-8 col-7">
                    <div className="float-right">
                      <div className="row">
                        <div className="back-box-game mr-2">
                          <img src={mask4} className="width-gane-image" />
                        </div>
                        <div className="back-box-game mr-2">
                          <img src={mask} className="width-gane-image" />
                        </div>
                        <div className="back-box-game mr-3">
                          <img src={mask6} className="width-gane-image" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-red mt-2">
                <div className="row">
                  <div className="col-md-4 col-5 mobile-top-game">
                    <h3 className="Pacifico-Regulars mobile-font-game font-family-size">
                      money/debt
                    </h3>
                  </div>
                  <div className="col-md-8 col-7">
                    <div className="float-right">
                      <div className="row">
                        <div className="back-box-game mr-2">
                          <img src={cardiver} className="width-gane-image" />
                        </div>
                        <div className="back-box-game mr-2">
                          <img src={mask2} className="width-gane-image" />
                        </div>
                        <div className="back-box-game mr-3">
                          <img src={cardiver} className="width-gane-image" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-brown mt-2">
                <div className="row">
                  <div className="col-md-4  col-5 mobile-top-game">
                    <h3 className="Pacifico-Regulars mobile-font-game font-family-size">
                      work/job
                    </h3>
                  </div>
                  <div className="col-md-8 col-7">
                    <div className="float-right">
                      <div className="row">
                        <div className="back-box-game mr-2">
                          <img src={mask6} className="width-gane-image" />
                        </div>
                        <div className="back-box-game mr-2">
                          <img src={mask} className="width-gane-image" />
                        </div>
                        <div className="back-box-game mr-3">
                          <img src={cardiver} className="width-gane-image" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-12 mobile-text-centers">
              <div className="blur-img blur-tops">
                <div className="back-deal height-width-blur">
                  <h2 className="text-center  text-white  w-86  Pacifico-Regulars top-blur-texte">-deal with your open situation-</h2>
                  <div className="text-center mt-4 mb-2">
                    <button type="text" className="draw-card-button Poppins-Bold open-situation-top">DRAW CARD</button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12 mobile-text-center">
              <div className="blur-img blur-top">
                <div className="blur-back height-width-blur">
                  <h4 className="top-blur-text">OPEN SITUATIONS</h4>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="text-right mobile-center">
                <button type="text" className="exit-game">
                  EXIT GAME
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dealopen;
